import './App.css';
import { Route, Routes } from 'react-router-dom';
import HomePageProjectOne from "../src/Project-A/Pages/HomePage"
import HomePageProjectTwo from "../src/Project-B/Pages/HomePage"
import { useEffect } from 'react';
function App() {
 useEffect(() =>{
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
 })
  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<HomePageProjectOne />} />
        <Route path='/home-2' element={<HomePageProjectTwo />} />
      </Routes>
    </div>
  );
}

export default App;
